import { render } from "./CountryCodePicker.vue?vue&type=template&id=8d3aaca4&scoped=true"
import script from "./CountryCodePicker.vue?vue&type=script&lang=js"
export * from "./CountryCodePicker.vue?vue&type=script&lang=js"

import "./CountryCodePicker.vue?vue&type=style&index=0&id=8d3aaca4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d3aaca4"],['__file',"src/components/phoneInput/CountryCodePicker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d3aaca4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d3aaca4', __exports__)) {
    console.log('reload')
    api.reload('8d3aaca4', __exports__)
  }
  
  module.hot.accept("./CountryCodePicker.vue?vue&type=template&id=8d3aaca4&scoped=true", () => {
    console.log('re-render')
    api.rerender('8d3aaca4', render)
  })

}


export default __exports__